import { ConfigOption, FormlyFieldConfig, FormlyExtension } from '@ngx-formly/core';
import {
  FormlyFieldInput,
  FormlyFieldInputIBAN,
  FormlyFieldTextArea,
  FormlyFieldText,
  FormlyFieldPoliceRegion,
  FormlyFieldKendoMultiSelect,
  FormlyFieldRadio,
  FormlyFieldCheckBox,
  FormlyFieldDate,
  FormlyFieldGridAfmetingen,
  FormlyFieldMultiCheckbox,
  FormlyFieldRepeat,
  RepeatTypeComponent,
} from 'app/_components/formly/types';
import {
  FormHorizontalWrapperComponent,
  CardWrapperComponent,
  PanelWrapperComponent,
  PrintBreakWrapperComponent,
  SectionWrapperComponent,
} from 'app/_components/formly/wrappers';

export const FIELD_TYPE_COMPONENTS = [
  // types
  FormlyFieldInput,
  FormlyFieldInputIBAN,
  FormlyFieldTextArea,
  FormlyFieldText,
  FormlyFieldPoliceRegion,
  FormlyFieldKendoMultiSelect,
  FormlyFieldRadio,
  FormlyFieldCheckBox,
  FormlyFieldDate,
  FormlyFieldGridAfmetingen,
  FormlyFieldRepeat,
  RepeatTypeComponent,

  // wrappers
  FormHorizontalWrapperComponent,
  CardWrapperComponent,
  PanelWrapperComponent,
  PrintBreakWrapperComponent,
  SectionWrapperComponent,
];

export function lifecycleFormlyExtension(field: FormlyFieldConfig) {
  if (field.key) {
    // if (field.key === 'RisicoOmschrijving.SoortPand') {
    //   field.hideExpression = (
    //     model: any,
    //     formState: any,
    //     field: FormlyFieldConfig
    //   ) => {
    //     if (model && model.RisicoOmschrijving && model.RisicoOmschrijving.SoortPand) {
    //       return model.RisicoOmschrijving.SoortPand === 'Flatwoning'; // || model.RisicoOmschrijving.SoortPand === 'Appartement';
    //     }
    //     return true;
    //   };
    // }
  }
}

export const FieldHooksExtension: FormlyExtension = {
  prePopulate: lifecycleFormlyExtension
};

export function minItemsValidationMessage(err, field: FormlyFieldConfig) {
  return `should NOT have fewer than ${field.templateOptions.minItems} items`;
}

export function maxItemsValidationMessage(err, field: FormlyFieldConfig) {
  return `should NOT have more than ${field.templateOptions.maxItems} items`;
}

export function minlengthValidationMessage(err, field: FormlyFieldConfig) {
  return `should NOT be shorter than ${field.templateOptions.minLength} characters`;
}

export function maxlengthValidationMessage(err, field: FormlyFieldConfig) {
  return `should NOT be longer than ${field.templateOptions.maxLength} characters`;
}

export function minValidationMessage(err, field: FormlyFieldConfig) {
  return `should be >= ${field.templateOptions.min}`;
}

export function maxValidationMessage(err, field: FormlyFieldConfig) {
  return `should be <= ${field.templateOptions.max}`;
}

export function multipleOfValidationMessage(err, field: FormlyFieldConfig) {
  return `should be multiple of ${field.templateOptions.step}`;
}

export function exclusiveMinimumValidationMessage(err, field: FormlyFieldConfig) {
  return `should be > ${field.templateOptions.step}`;
}

export function exclusiveMaximumValidationMessage(err, field: FormlyFieldConfig) {
  return `should be < ${field.templateOptions.step}`;
}

export function constValidationMessage(err, field: FormlyFieldConfig) {
  return `should be equal to constant "${field.templateOptions.const}"`;
}

export const BOOTSTRAP_FORMLY_CONFIG: ConfigOption = {
  extensions: [
    {
      name: 'hide_expression',
      extension: FieldHooksExtension
    }
  ],
  validationMessages: [
    { name: 'required', message: 'Veld is verplicht' },
    { name: 'null', message: 'should be null' },
    { name: 'minlength', message: minlengthValidationMessage },
    { name: 'maxlength', message: maxlengthValidationMessage },
    { name: 'min', message: minValidationMessage },
    { name: 'max', message: maxValidationMessage },
    { name: 'multipleOf', message: multipleOfValidationMessage },
    { name: 'exclusiveMinimum', message: exclusiveMinimumValidationMessage },
    { name: 'exclusiveMaximum', message: exclusiveMaximumValidationMessage },
    { name: 'minItems', message: minItemsValidationMessage },
    { name: 'maxItems', message: maxItemsValidationMessage },
    { name: 'uniqueItems', message: 'should NOT have duplicate items' },
    { name: 'const', message: constValidationMessage },
  ],
  types: [
    {
      name: 'input',
      component: FormlyFieldInput,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'inputiban',
      component: FormlyFieldInputIBAN,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'textarea',
      component: FormlyFieldTextArea,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'text',
      component: FormlyFieldText,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'cbpoliceregion',
      component: FormlyFieldPoliceRegion,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'kendomultiselect',
      component: FormlyFieldKendoMultiSelect,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'radio',
      component: FormlyFieldRadio,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'checkboxes',
      component: FormlyFieldCheckBox,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'date',
      component: FormlyFieldDate,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'grid-afmetingen',
      component: FormlyFieldGridAfmetingen
    },
    {
      name: 'multicheckbox',
      component: FormlyFieldMultiCheckbox,
      wrappers: ['form-field-horizontal'],
    },
    {
      name: 'repeat',
      component: FormlyFieldRepeat,
    },
    {
      name: 'repeat2',
      component: RepeatTypeComponent
    }
  ],
  wrappers: [
    //{ name: 'card', component: CardWrapperComponent },
    { name: 'printbreak', component: PrintBreakWrapperComponent },
    { name: 'panel', component: PanelWrapperComponent },
    { name: 'section', component: SectionWrapperComponent },
    { name: 'form-field-horizontal', component: FormHorizontalWrapperComponent }
  ],
};
